import { SQSUrl } from "./fetchVariables";

export default async function fetchSQS(route, method, body) {
   let fetchBody;
   if (method !== "GET") {
      fetchBody = {
         body: JSON.stringify(body),
      };
   } else {
      fetchBody = {};
   }
   const response = await fetch(SQSUrl + route, {
      method: method,
      headers: {
         "Content-type": "application/json",
         Accept: "application/json",
      },
      ...fetchBody,
   });

   if (response.ok) {
      return response.json();
   }

   throw new Error(`Response failed: ${response.status}`, {
      cause: response.json(),
   });
}
